document.addEventListener('click', function (event) {
  var button = event.target.closest('[data-load-more-button]');
  if (!button) return;

  event.preventDefault();

  var wrapper = button.closest('[data-load-more-wrapper]');
  var container = wrapper ? wrapper.closest('.product-grid-container') : null;
  var targetGrid = container ? container.querySelector('[data-load-more-grid]') : null;
  if (!wrapper || !targetGrid) return;

  var url = button.getAttribute('href');
  button.textContent = 'Loading…';
  button.setAttribute('aria-busy', 'true');
  button.setAttribute('disabled', 'disabled');

  fetch(url)
    .then(function (response) {
      return response.text();
    })
    .then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var newGrid = doc.querySelector('[data-load-more-grid]');
      var newWrapper = doc.querySelector('[data-load-more-wrapper]');

      if (newGrid) {
        while (newGrid.firstElementChild) {
          targetGrid.appendChild(newGrid.firstElementChild);
        }
      }

      if (newWrapper) {
        wrapper.replaceWith(newWrapper);
      } else {
        wrapper.remove();
      }
    })
    .catch(function () {
      button.textContent = 'Load More';
      button.removeAttribute('aria-busy');
      button.removeAttribute('disabled');
    });
});
